import { render, staticRenderFns } from "./DetailProfilCompanyPage.vue?vue&type=template&id=4d69c39c&"
import script from "./DetailProfilCompanyPage.vue?vue&type=script&lang=js&"
export * from "./DetailProfilCompanyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d69c39c')) {
      api.createRecord('4d69c39c', component.options)
    } else {
      api.reload('4d69c39c', component.options)
    }
    module.hot.accept("./DetailProfilCompanyPage.vue?vue&type=template&id=4d69c39c&", function () {
      api.rerender('4d69c39c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/DetailProfilCompanyPage.vue"
export default component.exports